/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CampsiteGeoJSON } from './CampsiteGeoJSON';
import {
    CampsiteGeoJSONFromJSON,
    CampsiteGeoJSONFromJSONTyped,
    CampsiteGeoJSONToJSON,
} from './CampsiteGeoJSON';
import type { CampsiteLabelGeoJSON } from './CampsiteLabelGeoJSON';
import {
    CampsiteLabelGeoJSONFromJSON,
    CampsiteLabelGeoJSONFromJSONTyped,
    CampsiteLabelGeoJSONToJSON,
} from './CampsiteLabelGeoJSON';

/**
 * Campsite Schema
 * @export
 * @interface Campsite
 */
export interface Campsite {
    /**
     * Campsite ID
     * @type {string}
     * @memberof Campsite
     */
    id: string;
    /**
     * Campsite Number
     * @type {string}
     * @memberof Campsite
     */
    number: string;
    /**
     * 
     * @type {CampsiteGeoJSON}
     * @memberof Campsite
     */
    campsiteGeojson: CampsiteGeoJSON;
    /**
     * 
     * @type {CampsiteLabelGeoJSON}
     * @memberof Campsite
     */
    campsiteLabelGeojson: CampsiteLabelGeoJSON;
}

/**
 * Check if a given object implements the Campsite interface.
 */
export function instanceOfCampsite(value: object): value is Campsite {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('campsiteGeojson' in value) || value['campsiteGeojson'] === undefined) return false;
    if (!('campsiteLabelGeojson' in value) || value['campsiteLabelGeojson'] === undefined) return false;
    return true;
}

export function CampsiteFromJSON(json: any): Campsite {
    return CampsiteFromJSONTyped(json, false);
}

export function CampsiteFromJSONTyped(json: any, ignoreDiscriminator: boolean): Campsite {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': json['number'],
        'campsiteGeojson': CampsiteGeoJSONFromJSON(json['campsite_geojson']),
        'campsiteLabelGeojson': CampsiteLabelGeoJSONFromJSON(json['campsite_label_geojson']),
    };
}

export function CampsiteToJSON(value?: Campsite | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'number': value['number'],
        'campsite_geojson': CampsiteGeoJSONToJSON(value['campsiteGeojson']),
        'campsite_label_geojson': CampsiteLabelGeoJSONToJSON(value['campsiteLabelGeojson']),
    };
}

